module.exports = __webpack_public_path__ + "img/bus2.e7518b5d.png";